import { Scalar, ScalarProvider } from "./Scalar";
import { Destructable } from "../../destructables";

export async function awaitCondition<T, S extends T>(
	variable: Scalar<T>,
	condition: (value: T) => value is S,
	destructor?: Destructable
): Promise<S>;
export async function awaitCondition<T>(
	variable: Scalar<T>,
	condition: (value: T) => boolean,
	destructor?: Destructable
): Promise<T>;
export async function awaitCondition<T, S extends T>(
	variable: Scalar<T>,
	condition: ((value: T) => value is S) | ((value: T) => boolean),
	destructor?: Destructable
): Promise<S> {
	if (!(variable instanceof ScalarProvider)) {
		if (!condition(variable)) throw new Error("unexpected");
		return Promise.resolve(variable as S);
	}
	return new Promise((resolve) => {
		let resolved = false;
		const subscription = {
			update: (value: T) => {
				if (resolved) return;
				if (condition(value)) {
					resolved = true;
					queueMicrotask(() => {
						resolve(value as S);
						if (destructor) {
							destructor.onDestroy(() => variable.unsubscribe(subscription));
						} else {
							variable.unsubscribe(subscription);
						}
					});
				}
			},
		};
		variable.subscribe(subscription);
	});
}
